import React, { useState } from "react";
import { supabase } from "../supabaseClient";
import { 
  ShieldAlert,  CheckCircle2, Loader2, ChevronRight 
} from "lucide-react";
import "../styles/ClaimForm.css";
import TopBar from "../components/TopBar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const ClaimForm = () => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    policy_number: "",
    claimant_name: "",
    incident_date: "",
    location: "",
    description: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { error } = await supabase.from("claims").insert([formData]);
    if (error) alert(error.message);
    else setSubmitted(true);
    setLoading(false);
  };

  if (submitted) {
    return (
      <div className="rni-success-overlay">
        <div className="rni-success-card">
          <div className="success-icon-bg"><CheckCircle2 size={40} color="#fff" /></div>
          <h2>Report Dispatched</h2>
          <p>An adjuster will review your file shortly.</p>
          <button onClick={() => setSubmitted(false)} className="rni-reset-btn">Return Home</button>
        </div>
      </div>
    );
  }

  return (
    <div>
        <TopBar />
        <Navbar />
        <div className="rni-claim-page">
      <div className="rni-claim-container">
        {/* SIDEBAR */}
        <div className="rni-claim-sidebar">
          <div className="sidebar-brand">
            <ShieldAlert size={32} />
            <span>Rift Insurance</span>
          </div>
          <div className="sidebar-content">
            <h1>Digital Claims <br/>Form</h1>
            <p>Fast-track your recovery with our automated intake system.</p>
          </div>
          <div className="sidebar-footer">
            <small>© 2026 Rift Insurance HQ</small>
          </div>
        </div>

        {/* MAIN FORM */}
        <div className="rni-claim-main">
          <form onSubmit={handleSubmit} className="rni-modern-form">
            <div className="rni-form-intro">
              <h3>Incident Details</h3>
              <p>Fill in the required fields to start your claim.</p>
            </div>

            <div className="rni-input-grid">
              {/* Floating Label Input */}
              <div className="rni-floating-group">
                <input type="text" name="policy_number" placeholder=" " required onChange={handleChange} />
                <label>Policy Number</label>
                <div className="rni-bar"></div>
              </div>

              <div className="rni-floating-group">
                <input type="text" name="claimant_name" placeholder=" " required onChange={handleChange} />
                <label>Full Name</label>
                <div className="rni-bar"></div>
              </div>

              <div className="rni-floating-group">
                <input type="date" name="incident_date" placeholder=" " required onChange={handleChange} />
                <label className="date-label">Date of Loss</label>
                <div className="rni-bar"></div>
              </div>

              <div className="rni-floating-group">
                <input type="text" name="location" placeholder=" " required onChange={handleChange} />
                <label>Location of Incident</label>
                <div className="rni-bar"></div>
              </div>
            </div>

            <div className="rni-floating-group full-width">
              <textarea name="description" placeholder=" " rows="4" required onChange={handleChange}></textarea>
              <label>What happened? (Detailed Description)</label>
              <div className="rni-bar"></div>
            </div>

            <button type="submit" className="rni-submit-glow" disabled={loading}>
              {loading ? <Loader2 className="rni-spin" /> : <>Submit Claim <ChevronRight size={18} /></>}
            </button>
          </form>
        </div>
      </div>
    </div>
        <Footer />
    </div>
  );
};

export default ClaimForm;